import { render } from "./RectangleBoxIcon.vue?vue&type=template&id=1bd06a1f&ts=true"
import script from "./RectangleBoxIcon.vue?vue&type=script&lang=ts"
export * from "./RectangleBoxIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__